import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StoreEndpointsConstant } from '@constants/store-endpoints.constant';
import { environment } from '@environments';
import { LineSearchOptions } from '@models/custom-fields.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LineService {
  constructor(private http: HttpClient) {}

  search(term: string, limit: number = 10): Observable<LineSearchOptions> {
    return this.http.get<LineSearchOptions>(StoreEndpointsConstant.LINE_SEARCH, {
      params: {
        searchQuery: term
      }
    });
  }
}
